import { buildCombinedDescription } from "./wizardconfig";

export const createDocumentStories = async ({
    stories,
    uploadedFile,
    inputTab,
    confluenceUrl,
    projectId,
}) => {
    const token = localStorage.getItem('token');
    const apiRoot = process.env.REACT_APP_API_URL || '';

    const createdStories = [];

    for (const story of stories) {
        if (!story.jiraProjectId) {
            throw new Error(`Please select a Jira project for story: ${story.title}`);
        }

        if (!story.issueTypeId && !story.issueType) {
            throw new Error(`Please select an issue type for story: ${story.title}`);
        }

        if (!story.reporter) {
            throw new Error(`Please select a reporter for story: ${story.title}`);
        }

        const combinedDescription = buildCombinedDescription(
            story.description,
            story.acceptanceCriteria,
        );

        const finalDescription =
            inputTab === 'url' && confluenceUrl
                ? `${combinedDescription}\n\nConfluence Document: ${confluenceUrl}`
                : combinedDescription;

        const issuePayload = {
            fields: {
                summary: story.title?.trim(),
                issuetype: {
                    id: story.issueTypeId || story.issueType,
                },
                project: {
                    id: story.jiraProjectId,
                },
                reporter: {
                    id: story.reporter,
                },
                ...(story.assignee
                    ? {
                        assignee: {
                            id: story.assignee,
                        },
                    }
                    : {}),
                ...(finalDescription
                    ? {
                        description: finalDescription,
                    }
                    : {}),
                ...(story.priorityId
                    ? {
                        priority: {
                            id: story.priorityId,
                        },
                    }
                    : {}),
                ...(story.labels?.length > 0
                    ? {
                        labels: story.labels,
                    }
                    : {}),
            },
            entityUrl: null,
            entityKey: null,
            entityType: null,
            entityId: null,
            attachments: [],
        };

        const unifiedFormData = new FormData();
        unifiedFormData.append('issueData', JSON.stringify(issuePayload));

        if (inputTab === 'file' && uploadedFile instanceof File) {
            unifiedFormData.append('files', uploadedFile);
        }

        const response = await fetch(`${apiRoot}/api/v1/jira/create-issue`, {
            method: 'POST',
            body: unifiedFormData,
            headers: {
                Authorization: `${token}`,
                'X-Project-Id': projectId,
            },
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));

            throw new Error(
                errorData?.error?.message ||
                errorData?.message ||
                `Failed to create Jira story: ${story.title}`,
            );
        }

        const responseData = await response.json();

        createdStories.push({
            id: responseData?.jira?.id ?? null,
            key: responseData?.jira?.key,
            title: story.title,
            description: finalDescription,
            priority: story.priority ?? '',
            issuestatus: story.issuestatus ?? '',
            url: responseData?.jira?.url ?? null,
            jiraProjectId: story.jiraProjectId,
        });
    }

    return createdStories;
};
